export default __webpack_public_path__ + "static/export-706daa2b4c691506aeee4e41009e3080.gif";